<template>
  <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>52F0E22A-754A-4E7D-B19E-C54AF38B0AE9</title>
    <defs>
      <filter id="filter-1">
        <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
      </filter>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard---Freelance-Tasks---Pending" transform="translate(-1030.000000, -562.000000)">
        <g id="List" transform="translate(370.000000, 374.000000)">
          <g id="Molecules/Task/Log" transform="translate(0.000000, 180.000000)">
            <g id="Variables/Icon/Play" transform="translate(660.000000, 8.000000)" filter="url(#filter-1)">
              <g id="Icon" fill="#000000" fill-rule="nonzero">
                <polygon id="" points="13 21.64 22.14 15.82 13 10"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PlayIcon',
};
</script>

<style scoped>

</style>
